"use client"
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { decryptId } from "../../utils/crypto";

export default function ProjectDetails() { 
  const { id } = useParams();
  const decryptedId = decryptId(id);
  const [project, setProject] = useState(null);

  useEffect(() => {
    if (decryptedId) {
      fetchProjectDetails();
    }
  }, [decryptedId]);

  const fetchProjectDetails = async () => {
    try {
      const response = await fetch(`http://localhost:5000/client-project/${decryptedId}`);
      const data = await response.json();
      setProject(data);
    } catch (error) {
      console.error('Error fetching project details:', error);
    }
  };

  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <section style={{ background: 'var(--bg-card)', padding: '28px', borderRadius: '16px', border: '1px solid var(--border-glass)', marginBottom: '28px', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
      <h1 style={{ fontSize: '1.6rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginBottom: '12px' }}>{project.title}</h1>
      <p style={{ marginBottom: '20px', color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: 1.6 }}>{project.description}</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <h2 style={{ fontSize: '0.8rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>Budget</h2>
          <p style={{ color: 'var(--text-primary)', fontWeight: 600 }}>{project.budget_range}</p>
        </div>
        <div>
          <h2 style={{ fontSize: '0.8rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>Deadline</h2>
          <p style={{ color: 'var(--text-primary)', fontWeight: 600 }}>
            {new Date(project.deadline).toLocaleDateString('en-GB')}
          </p>
        </div>
        <div>
          <h2 style={{ fontSize: '0.8rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>Required Skills</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {project.skills.split(',').map((skill) => (
              <span key={skill} style={{
                padding: '3px 12px', borderRadius: '9999px', fontSize: '0.7rem', fontWeight: 600,
                background: 'rgba(0,212,255,0.08)', color: 'var(--accent-cyan)', border: '1px solid rgba(0,212,255,0.15)',
              }}>{skill.trim()}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}